<template>
    <div class="return-prop" v-if="source && returnType">
        <div class="return-prop-div">
            <!-- <form> -->
            <div class="return-form">
                <div>
                    <!-- 主品 -->
                    <!-- <div>==主品====</div> -->
                    <div>
                        <div class="trial-items">
                            <div v-for="(outerItem, outerIndex) in source.detail.goods_list" :key="'1_' + outerIndex">
                                <div v-for="(innerItem, innerIndex) in outerItem.main" :key="'2_' + innerIndex">
                                    <!-- 选中 e622 未选中 e677-->
                                    <div class="item-base">
                                        <!-- <div bind:tap="onChangeReturnItem" 
                                            :class="` selectIcon ${(returnNumberList[innerItem.id]&&returnNumberList[innerItem.id].select)?'iconselect':'iconNotSelect'}`">
                                        </div> -->
                                        <div class="select-singel">
                                            <i @click="onChangeReturnItem(innerItem)"
                                                class="selectIcon iconfont select-all">{{
                                                    (returnNumberList[innerItem.id] &&
                                                        returnNumberList[innerItem.id].select)
                                                        ? '&#xe640;' : '&#xe60f;' }}</i>
                                        </div>
                                        <div class="item-image">
                                            <img :src="innerItem.pic" />
                                        </div>
                                        <div class="item-intro">
                                            <div class="item-info1">
                                                <div class="item-name">{{ innerItem.name }}</div>
                                                <div class="item-count">x {{ innerItem.qty || 1 }}</div>
                                                <div class="item-select">
                                                    <div class="more-btns">
                                                        <countBox :max="innerItem.qty || 1"
                                                            :value="(returnNumberList[innerItem.id] && returnNumberList[innerItem.id].num) || 1"
                                                            @change="(v) => { returnNumberChange(v, innerItem.id) }">
                                                        </countBox>
                                                        <!-- <count-box bind:callChange="returnNumberChange"
                                                            data-key="{{innerItem.id}}"
                                                            max="{{innerItem.quantity || 1}}" min="{{1}}"
                                                            value="{{(returnNumberList[innerItem.id]&&returnNumberList[innerItem.id].num) || 1}}"></count-box> -->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 赠品 -->
                    <div>
                        <div v-if="source.detail.goods_free && source.detail.goods_free.length > 0" class="trial-items">
                            <div v-for="(item, index) in source.detail.goods_free" :key="'3_' + index" class="item-base">
                                <div class="select-singel">
                                    <i @click="onChangeReturnItem(item)" class="selectIcon iconfont select-all">{{
                                        (returnNumberList[item.id] && returnNumberList[item.id].select)
                                            ? '&#xe640;' : '&#xe60f;' }}</i>
                                </div>
                                <div class="item-image">
                                    <img :src="item.pic" />
                                </div>
                                <div class="item-intro">
                                    <div class="item-info1">
                                        <div class="item-name">{{ item.name }}</div>
                                        <div class="item-count">x {{ item.qty || 1 }}</div>
                                        <div class="item-select">
                                            <div class="more-btns">
                                                <countBox :max="item.qty || 1"
                                                    :value="(returnNumberList[item.id] && returnNumberList[item.id].num) || 1"
                                                    @change="(v) => { returnNumberChange(v, item.id) }">
                                                </countBox>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div>赠品2</div> -->
                    <div>
                        <div v-if="source.detail.group_gifts && source.detail.group_gifts.length > 0" class="trial-items">
                            <div v-for="(item, index) in source.detail.group_gifts" :key="'4_' + index" class="item-base">
                                <div class="select-singel">
                                    <i @click="onChangeReturnItem(item)" class="selectIcon iconfont select-all">{{
                                        (returnNumberList[item.id] && returnNumberList[item.id].select)
                                            ? '&#xe640;' : '&#xe60f;' }}</i>
                                </div>
                                <div class="item-image">
                                    <img :src="item.pic" />
                                </div>
                                <div class="item-intro">
                                    <div class="item-info1">
                                        <div class="item-name">{{ item.name }}</div>
                                        <div class="item-count">x {{ item.qty || 1 }}</div>
                                        <div class="item-select">
                                            <div class="more-btns">
                                                <countBox :max="item.qty || 1"
                                                    :value="(returnNumberList[item.id] && returnNumberList[item.id].num) || 1"
                                                    @change="(v) => { returnNumberChange(v, item.id) }">
                                                </countBox>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 积分兑换商品 -->
                <!-- <div>赠品3</div> -->
                <div v-if="source.detail.product_coupon_sku && source.detail.product_coupon_sku.length">
                    <div class="trial-items">
                        <div v-for="item in source.detail.product_coupon_sku" :key="item.id" class="item-base">
                            <div class="select-singel">
                                <i @click="onChangeReturnItem(item)" class="selectIcon iconfont select-all">{{
                                    (returnNumberList[item.id] && returnNumberList[item.id].select)
                                        ? '&#xe640;' : '&#xe60f;' }}</i>
                            </div>
                            <div class="item-image">
                                <img :src="item.pic" />
                            </div>
                            <div class="item-intro">
                                <div class="item-info1">
                                    <div class="item-name">{{ item.name }}</div>
                                    <div class="item-count">x {{ item.qty || 1 }}</div>
                                    <div class="item-select">
                                        <div class="more-btns">
                                            <countBox :max="item.qty || 1"
                                                :value="(returnNumberList[item.id] && returnNumberList[item.id].num) || 1"
                                                @change="(v) => { returnNumberChange(v, item.id) }">
                                            </countBox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="return-btns">
                <button class="default-btn" @click="hideReturnView">关闭</button>
                <button class="primary-btn" @click="onReturn">确定</button>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/utils/api';
import types from '@/store/types';
import countBox from '@/components/form/countBox';
export default {
    name: "returnGoods",
    components: {
        countBox,
    },
    props: {
        source: {},
        returnType: {},
    },
    data() {
        return {
            returnNumberList: [],
            sendForm: {
                express_company: '',
                express_no: '',
            },
        }
    },
    created() {
    },
    methods: {
        onChangeReturnItem(item) {
            console.log('勾选', item)
            let returnNumberList = this.returnNumberList
            let k = item.id
            if (k) {
                if (returnNumberList[k]) {
                    //   returnNumberList[k].select = !returnNumberList[k].select
                    this.$set(returnNumberList[k], 'select', !returnNumberList[k].select)
                } else {
                    this.$set(returnNumberList, k, {
                        select: true,
                        num: 1,
                    })
                }
                this.returnNumberList = returnNumberList
            }

        },
        returnNumberChange(val, k) {
            console.log(val, k)
            let returnNumberList = this.returnNumberList
            if (k) {
                if (returnNumberList[k]) {
                    this.$set(this.returnNumberList[k], 'num', val)
                } else {
                    this.$set(this.returnNumberList, [k], {
                        select: true,
                        num: val
                    })
                }
            }
            console.log(this.returnNumberList)
        },
        hideReturnView() {
            this.$emit("cancel")
        },
        onReturn() {
            let returnIds = {}
            let isOpen = false;
            let returnNumberList = this.returnNumberList;
            for (let i in returnNumberList) {
                if (returnNumberList[i].select) {
                    isOpen = true;
                    returnIds[i] = returnNumberList[i].num || 1
                }
            }
            console.log(returnIds)
            if (!isOpen) {
                this.$toast({ message: '请选择商品', iconCls: "failure" });
                return;
            }
            let sendForm = {
                item: returnIds,
                order_id: this.source.order_id,
                express_company: this.express_company,
                express_no: this.express_no,
            }
            if (this.returnType == '1') {
                sendForm.type = '1'
            } else if (this.returnType == '2') {
                if (this.source.order_status == 3) {
                    sendForm.type = '2'
                } else if (this.source.order_status == 9 || this.source.order_status == 10) {
                    sendForm.type = '4'
                }
            } else if (this.returnType == '4') {
               
                 if (this.source.order_status == 4) {
                    sendForm.type = '5'
                } else if (this.source.order_status == 9 || this.source.order_status == 10) {
                    sendForm.type = '3'
                }
            }
            console.log(sendForm, this.returnType, this.source.order_status)
            api[types.CREATE_MANUAL_AFTER_SALES](sendForm).then((res) => {
                console.log("申请成功",res)
                if(res.code==1){
                    this.$toast({ message: '申领成功' });
                    this.$emit("succeed")
                }else{
                      this.$toast({ message: res.message, iconCls: "failure" });
                }
            }).catch()
        },
    },
    watch: {}
}
</script>

<style lang="scss" scoped>
.return-prop {
    max-width: 80vw;
    width: 700px;
    margin: auto;

    .return-prop-div {
        padding-top: 40px;
        padding-bottom: 20px;
        background-color: #fff;

        .return-form {
            height: calc(70vh - 50px);
            max-width: 90%;
            width: 500px;
            overflow: auto;
            padding: 0 0 15px 0px;
            margin: 0 auto;

            .form-item {
                display: flex;
                justify-content: space-between;

                margin: 10px auto 0;
                line-height: 30px;

                .form-name {
                    width: 5em;
                }

                .form-value {
                    width: calc(100% - 8em);
                    text-align: right;
                }
            }
        }

        .return-btns {
            margin-top: 10px;
            height: 40px;
            display: flex;
            justify-content: space-around;
            width: 300px;
            max-width: 90%;
            margin: auto;

            button {
                cursor: pointer;
                width: 100px;
                height: 40px;
                line-height: 40px;

                &.default-btn {
                    border: 1px solid #999;
                }

                &.primary-btn {
                    background-color: #000;
                    color: #fff;
                }
            }
        }

        .trial-items {
            margin: 20px auto 0;
            // width: 690px;

            // 商品信息基本结构布局
            .item-base {
                width: 100%;
                margin-top: 20px;
                display: flex;
                justify-content: flex-start;
                align-items: center;

                &:first-child {
                    margin-top: 0;
                }

                .selectIcon {
                    margin-right: 15px;
                    cursor: pointer;
                }

                .item-image {
                    width: 60px;
                    height: 80px;
                    background: #D7D8D8;
                }

                .item-intro {
                    margin-left: 40px;
                    width: calc(100% - 120px);
                    min-height: 80px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;

                    .item-info {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;

                        .item-name {
                            white-space: normal;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                            overflow: hidden;
                        }

                        .item-count {
                            display: none;
                            font-size: 12px;
                            color: #575757;
                        }
                    }

                    .item-info1 {
                        height: 100%;

                        .item-name {
                            white-space: normal;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                            overflow: hidden;
                        }

                        .item-count {
                            margin-top: 5px;
                            font-size: 14px;
                            color: #575757;
                        }
                    }
                }
            }
        }


    }

    .selectIcon {
        width: 32px;
        height: 32px;

        &.iconselect {
            // @include iconfont('\e622');
            font-size: 32px;
        }

        &.iconNotSelect {
            // @include iconfont('\e677');
            font-size: 32px;
        }
    }

    .item-select {
        // margin-top: 10px;
        display: flex;
        justify-content: end;
        justify-content: flex-end;

        .more-btns {
            // width: 240px;
            // height: 70px;
        }
    }

}
</style>